import { useEffect, useState } from 'react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import * as state from '@/components/Analysis/state';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { useGetAllAssembliesForEvaluationQuery } from '@/__generated__/graphql';
import { useGetAssemblyTemplates } from '@/hooks/useGetAssemblyTemplates';

export const useGetAssemblies = () => {
  const structureId = useGetStructureId();
  useGetAssemblyTemplates();

  const setAllAssemblies = useSetAtom(state.allAssembliesForReview);
  const selectedTemplateFilters = useAtomValue(state.selectedTemplateFiltersState);
  const filteredDeckIds = useAtomValue(state.selectedFilteredDeckIds);
  const selectedPaintRegionIds = useAtomValue(state.selectedFilteredPaintRegionIds);
  const selectedWorkpackIds = useAtomValue(state.selectedFilteredWorkpackIds);
  const templateId = useAtomValue(state.selectedAssemblyTemplateId)!;
  const [applyFilters, setApplyFilters] = useAtom(state.applyFilters);

  const [appliedTemplateFilters, setAppliedTemplateFilters] = useState(selectedTemplateFilters);
  const [appliedDeckFilters, setAppliedDeckFilters] = useState(filteredDeckIds);
  const [appliedPaintRegionFilters, setAppliedPaintRegionFilters] =
    useState(selectedPaintRegionIds);
  const [appliedWorkpackFilters, setAppliedWorkpackFilters] = useState(selectedWorkpackIds);

  useGetAllAssembliesForEvaluationQuery({
    variables: {
      input: {
        structureId,
        templateId,
        selectedTemplateFilters: appliedTemplateFilters,
        selectedDeckIds: appliedDeckFilters,
        selectedPaintRegionIds: appliedPaintRegionFilters,
        selectedWorkpackIds: appliedWorkpackFilters,
      },
    },
    onCompleted: (data) => {
      if (data?.getAssembliesByTemplateFieldsFilters) {
        setAllAssemblies(data.getAssembliesByTemplateFieldsFilters);
        setApplyFilters(false);
      }
    },
    onError: (error) => {
      console.error(error.message);
    },
  });

  useEffect(() => {
    if (applyFilters) {
      setAppliedTemplateFilters(selectedTemplateFilters);
      setAppliedDeckFilters(filteredDeckIds);
      setAppliedPaintRegionFilters(selectedPaintRegionIds);
      setAppliedWorkpackFilters(selectedWorkpackIds);
    }
  }, [
    applyFilters,
    filteredDeckIds,
    selectedPaintRegionIds,
    selectedTemplateFilters,
    selectedWorkpackIds,
  ]);
};
